/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
const initialState = {
  cuenta_predial: null,
  curt: null,
  clave_catastral: null,
  bimestre: null,
  anio: null,
  total: 110,
  descripcion: null,
  predio_oid: null,
};

const mutations = {
  SET_DATA(state, payload) {
    Object.assign(state, payload, {
      descripcion: payload.descripcion.replace(/certificado/i, 'CERTIFICADO'),
    });
  },
  CLEAR_DATA(state) {
    state = initialState;
  },
};

const actions = {
  SET_DATA({ commit }, payload) {
    if (typeof payload === 'object') {
      commit('SET_DATA', payload);
    }
  },
  CLEAR_DATA({ commit }) {
    commit('CLEAR_DATA');
  },
};

export default {
  state: initialState,
  mutations,
  actions,
  namespaced: true,
};
